export function Close() {
  return (
    <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.925781"
        width="12.8327"
        height="1.30946"
        transform="rotate(45 0.925781 0)"
      />
      <rect
        y="9.07404"
        width="12.8327"
        height="1.30946"
        transform="rotate(-45 0 9.07404)"
      />
    </svg>
  );
}
